import { render, staticRenderFns } from "./HeaderOnlyLayout.vue?vue&type=template&id=5bf7e1d3&scoped=true"
var script = {}
import style0 from "./HeaderOnlyLayout.vue?vue&type=style&index=0&id=5bf7e1d3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf7e1d3",
  null
  
)

export default component.exports